<template>
  <div style="display: flex;align-items: center;height: 100vh">
    <div style="display: flex;justify-content: center;width: 100vw">
      <img style="width: 500px;height: 920px;" mode="aspectFill" src="../assets/img/login_bg.png"/>
      <div style="width: 940px;background-color: white">
        <div style="width: 460px;margin:250px auto;">
          <div style="display: flex;margin-bottom: 20px;align-items: center">
            <img style="width: 50px;height: 50px;" mode="aspectFill" src="../assets/img/toplogo.png"/>
            <div style="font-size: 24px;font-weight: 500;border-left: 1px solid #c6c6c6;padding-left: 40px;margin-left: 40px">Login</div>
          </div>
          <el-form :model="form" :rules="rules" ref="ruleForm" label-position="top">
            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input type="password" v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="width: 100%;background-color: #FB9348;color: white;height: 40px;margin-top: 40px" @click="submitForm()">Login</el-button>
            </el-form-item>
          </el-form>
          <div @click="goRegister" style="font-size: 14px">Don't have an account yet?<span style="color: #FB9348;cursor: pointer;"> Click here & apply for an account</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang:'CN',
      form:{
        email:'',
        password:'',
      },
      rules: {
        email: [
          { required: true, message: 'Please enter your email', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter your password', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$http.post("/gene/user/login",this.form)
              .then(res => {
                if (res.data.code === 500) {
                  this.$message.error('Email or password does not exist');
                }else {
                  this.setLocalStorage('login',true)
                  localStorage.setItem("userId",res.data.data.userId);
                  this.$message.success('Login Success');

                  this.$router.push({
                    path: `/`,
                  })
                }
              })
        } else {
          return false;
        }
      });
    },
    setLocalStorage(key, value) {
      localStorage.setItem(key, value)
      // 手动触发事件
      window.dispatchEvent(new StorageEvent('storage', {
        key: key,
        newValue: value,
        oldValue: localStorage.getItem(key),
        storageArea: localStorage,
        url: window.location.href
      }))
    },
    goRegister(){
      this.$router.push({
        path: `/register`,
      })
    }
  }
}
</script>

<style scoped>
/deep/ .el-form-item__label {
  padding: 0px;
  margin-top: 10px;
}
</style>
